import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-order-cancel-dialog',
  template: `
    <h2 mat-dialog-title>Отмена заказа №{{ data.id }}</h2>
    <mat-dialog-content>
      <p>Заказ и причина останутся в истории. Резервы будут освобождены по обычным правилам отмены.</p>
      <mat-form-field appearance="outline">
        <mat-label>Причина отмены</mat-label>
        <mat-select [(ngModel)]="reason" required>
          <mat-option *ngFor="let item of reasons" [value]="item">{{ item }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Комментарий{{ reason === 'Другая причина' ? ' (обязательно)' : '' }}</mat-label>
        <textarea matInput [(ngModel)]="comment" rows="2" maxlength="400"></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Назад</button>
      <button mat-raised-button color="warn" [disabled]="!canSave" (click)="save()">Отменить заказ</button>
    </mat-dialog-actions>
  `,
  styles: ['mat-form-field { display: block; width: 100%; } p { margin-top: 0; }']
})
export class OrderCancelDialogComponent {
  readonly reasons = [
    'Нет свободного остатка', 'Не устроил срок доставки', 'Не устроила цена',
    'Не подошла запчасть', 'Клиент отказался', 'Не удалось связаться',
    'Дубликат заказа', 'Тестовый заказ', 'Другая причина'
  ];
  reason = '';
  comment = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
    private dialogRef: MatDialogRef<OrderCancelDialogComponent, string>
  ) {}

  get canSave(): boolean {
    return Boolean(this.reason && (this.reason !== 'Другая причина' || this.comment.trim()));
  }

  save(): void {
    if (!this.canSave) return;
    this.dialogRef.close([this.reason, this.comment.trim()].filter(Boolean).join(': '));
  }
}
